import React from 'react';
import TilesBoard from '../../../components/UI/TilesBoard/TilesBoard';
import CalendarIcon from '../../../brandConfig/assets/svg/calendar.svg';
import StarIcon from '../../../brandConfig/assets/svg/star.svg';

export default (props) => {
  const tiles = [
    {
      title: 'Pay As You Go',
      icon: <CalendarIcon />,
      actionPayload: 'class-pass-member',
      cyId: 'classPassesTile'
    },
    {
      title: 'Membership',
      icon: <StarIcon />,
      actionPayload: 'full-member',
      cyId: 'membershipTile'
    }
  ];

  const accountTypeSelected = (type) => {
    props.typeSelected(type);
  };

  return <TilesBoard tiles={tiles} action={accountTypeSelected} />;
};
